import React from 'react';
import { Button, ButtonGroup } from "react-bootstrap";

const Row = ({ config, onRemove, onUpdate, partners }) => {
    const mgidStyle = config.mgidStyle ? '+' : '';
    const paused = config.paused ? '+' : '';

    return (<tr>
        <td style={{ textAlign: 'left' }}>{config.affid}</td>
        <td>{config.name}</td>
        <td>{config.partnerId && partners[config.partnerId]}</td>
        <td>{config.zone}</td>
        <td>{config.type}</td>
        <td>{config.monetization}</td>
        <td>{config.creative}</td>
        <td>{config.auth}</td>
        <td>{config.factor}</td>
        <td>{config.weekendFactor}</td>
        <td>{config.roi}</td>
        <td>{mgidStyle}</td>
        <td>{paused}</td>
        <td>
            <ButtonGroup>
                <Button bsStyle="info" onClick={() => onUpdate(config)}>Update</Button>
                <Button bsStyle="danger" onClick={() => onRemove(config.affid)}>Remove</Button>
            </ButtonGroup>
        </td>
    </tr>);

};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/PushapiConfig/components/Table/components/Row/index.js